<div class="flex justify-between items-center">
  <h1 class="text-3xl my-6">
    <ng-content></ng-content>
  </h1>
  <div class="action">
    <ng-content select="[action]"></ng-content>
  </div>
</div>
